<card [translationsPath]="translationsPath" [fullScreen]="state.isFullScreen">
  <div header-title-after *nonVisitor>
    <div
      class="button-group"
      *ngIf="appState.hasModule(LxmAppModule.ReceiveOffers)"
    >
      <lxm-button
        routerLink="/offers/sending"
        label=".title_sent_offers"
        [class.active]="kind == OfferKind.SupplierOffer"
        *ngIf="appState.hasModule(LxmAppModule.SendOffers) && appState.hasRight([UserAction.ViewSupplierOffers])"
      >
      </lxm-button>
      <lxm-button
        routerLink="/offers/receiving"
        label=".title_received_offers"
        [class.active]="kind == OfferKind.ReceivingOffer"
        *ngIf="appState.hasRight([UserAction.ViewReceivedOffers])"
      >
      </lxm-button>
      <lxm-button
        routerLink="/offers/requests"
        label=".title_requested_offers"
        [class.active]="kind == OfferKind.OfferRequest"
        *ngIf="appState.hasRight([UserAction.ManageReceivedOffers])"
      >
      </lxm-button>
    </div>
  </div>

  <div header-actions [formGroup]="controls" *nonVisitor>
    <selected-offers
      [isSelected]="isOfferSelected"
      [(selection)]="selection"
      [(currentPageSelected)]="currentPageSelected"
      [kind]="kind"
    >
    </selected-offers>

    <ng-container
      *ngIf="kind == OfferKind.ReceivingOffer || kind == OfferKind.OfferRequest"
    >
      <ng-container *ngIf="kind == OfferKind.ReceivingOffer">
        <filter-select
          [options]="receivingOffersListViewTypeOptions"
          for="listViewType"
          [clearable]="false"
          value="id"
          labelField="label"
          (change)="setListView($event?.id)"
        ></filter-select>

        <!-- <div class="button-group">
          <lxm-button
            [class.active]="isListViewActive(OffersListViewType.All)"
            label="cards.offers.filters.all"
            (click)="setListView(OffersListViewType.All)"
          >
          </lxm-button>
          <lxm-button
            [class.active]="isListViewActive(OffersListViewType.Active)"
            label="cards.offers.filters.active"
            (click)="setListView(OffersListViewType.Active)"
          >
          </lxm-button>
          <lxm-button
            [class.active]="isListViewActive(OffersListViewType.Archive)"
            label="cards.offers.filters.archive"
            (click)="setListView(OffersListViewType.Archive)"
          >
          </lxm-button>
        </div> -->
        <div class="flex flex-row gap-inherit">
          <lxm-button
            *ngIf="appState.supportedOfferImport.indexOf(appState.contentTenantId) >= 0"
            type="beige"
            icon="imports"
            label="action.import"
            (click)="openImportDialog()"
          >
          </lxm-button>
          <lxm-button
            type="beige"
            icon="excel"
            subscriptionRestricted
            (onUnrestrictedClick)="exportOffers()"
            [disabled]="selection.length < 1"
            [title]="'cards.offers.action_description.xsl_export' | translate"
          >
          </lxm-button>
        </div>
      </ng-container>

      <ng-container *ngIf="kind == OfferKind.OfferRequest">
        <filter-select
          [options]="requestedOffersListViewTypeOptions"
          for="listViewType"
          [clearable]="false"
          value="id"
          labelField="label"
          (change)="setListView($event?.id)"
        ></filter-select>

        <!-- <div class="button-group">
          <lxm-button
            [class.active]="isListViewActive(OffersListViewType.All)"
            label="cards.offers.filters.all"
            (click)="setListView(OffersListViewType.All)"
          >
          </lxm-button>
          <lxm-button
            [class.active]="isListViewActive(OffersListViewType.RequestDrafts)"
            label="cards.offers.filters.drafts"
            (click)="setListView(OffersListViewType.RequestDrafts)"
          >
          </lxm-button>
          <lxm-button
            [class.active]="isListViewActive(OffersListViewType.SentRequests)"
            label="cards.offers.filters.sent"
            (click)="setListView(OffersListViewType.SentRequests)"
          >
          </lxm-button>
        </div> -->

        <lxm-button
          type="green"
          icon="plus-dark"
          label=".action.request_offer"
          routerLink="/offers/request"
          *requiredRights="[UserAction.ManageReceivedOffers]"
        >
        </lxm-button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="kind == OfferKind.SupplierOffer">
      <filter-select
        [options]="sentOffersListViewTypeOptions"
        for="listViewType"
        [clearable]="false"
        value="id"
        labelField="label"
        (change)="setListView($event?.id)"
      ></filter-select>

      <!-- <div class="button-group">
        <lxm-button
          [class.active]="isListViewActive(OffersListViewType.All)"
          label="cards.offers.filters.all"
          (click)="setListView(OffersListViewType.All)"
        >
        </lxm-button>
        <lxm-button
          [class.active]="isListViewActive(OffersListViewType.Saved)"
          label="cards.offers.filters.saved"
          (click)="setListView(OffersListViewType.Saved)"
        >
        </lxm-button>
        <lxm-button
          [class.active]="isListViewActive(OffersListViewType.Active)"
          label="cards.offers.filters.active"
          (click)="setListView(OffersListViewType.Active)"
        >
        </lxm-button>
        <lxm-button
          [class.active]="isListViewActive(OffersListViewType.Archive)"
          label="cards.offers.filters.archive"
          (click)="setListView(OffersListViewType.Archive)"
        >
        </lxm-button>
      </div> -->

      <lxm-button
        type="green"
        *requiredRights="[UserAction.ManageSupplierOffers]"
        icon="plus-dark"
        label=".action.create_offer"
        routerLink="/offers/new"
      >
      </lxm-button>
      <lxm-button
        type="beige"
        icon="excel"
        subscriptionRestricted
        (onUnrestrictedClick)="exportOfferList()"
        [title]="'cards.offers.action_description.xsl_export' | translate"
      >
      </lxm-button>
      <!-- [disabled]="!appState.hasSubscription" -->

    </ng-container>
  </div>

  <div body class="sticky-table">
    <div class="sticky-table-body overflow-x w-full">
      <mat-table
        [dataSource]="dataSource"
        matSort
        [@.disabled]="true"
        [zoomValue]="state.zoom"
      >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="offer_select" sticky>
          <mat-header-cell *matHeaderCellDef>
            <div class="f-1 align-center flex justify-center">
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="isAllSelected()"
                [indeterminate]="!isAllSelected()"
              >
              </mat-checkbox>
            </div>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            stop-propagation
            (click)="$event ? toggleSelection(row) : null"
          >
            <div class="f-1 align-center flex justify-center">
              <mat-checkbox
                class="table-checkbox"
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleSelection(row) : null"
                [checked]="isOfferSelected(row)"
                *ngIf="isAcceptedSelectionType(row.type?.id)"
              >
              </mat-checkbox>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="retailer_image" sticky>
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <image-popover
              imageUrl="clients/{{row.retailerId}}/logo/withDefaultImageFallback"
            ></image-popover>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="supplier_image" sticky>
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <image-popover
              imageUrl="suppliers/{{row.retailerSupplierId ?? row.supplierId}}/logo/withDefaultImageFallback"
            ></image-popover>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="retailer">
          <mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>
              {{(translationsPath + '.table.retailer') | translate}}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="gap-5x">
            <image-popover
              imageUrl="clients/{{row.retailerId}}/logo/withDefaultImageFallback"
            ></image-popover>
            <span class="flex flex-row"> {{row.retailer}} </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="supplier">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{(translationsPath + '.table.offer_supplier') | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="gap-5x">
            <image-popover
              imageUrl="suppliers/{{row.retailerSupplierId ?? row.supplierId}}/logo/withDefaultImageFallback"
            ></image-popover>
            <span class="flex flex-row"> {{row.supplier}} </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sentAt">
          <mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>
              {{(translationsPath + '.table.offer_sentAt') | translate}}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="flex flex-row"> {{row.sentAt | formDate:"L HH:mm"}} </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="period">
          <mat-header-cell *matHeaderCellDef>
            <div mat-sort-header>
              {{(translationsPath + '.table.period_date') | translate}}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="triple-rows">
              <div class="flex gap-4">
                <div class="flex min-w-[85px] flex-col">
                  <span class="cell-row caption-regular">
                    {{'global.from' | translate}}:
                  </span>
                  <span class="cell-row"> {{row.from | formDate}} </span>
                </div>
                <div class="flex min-w-[85px] flex-col">
                  <span class="cell-row caption-regular">
                    {{'global.to' | translate}}:
                  </span>
                  <span class="cell-row"> {{row.to | formDate}} </span>
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="suppliers">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{(translationsPath + '.table.offer_suppliers') | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="flex flex-row">
              <div class="comma-delimited-list">
                <span *ngFor="let supplier of row.suppliers">
                  {{supplier.name}}
                </span>
              </div>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="to">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{(translationsPath + '.table.offer_valid_date') | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{row.to | formDate}} </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{(translationsPath + '.table.offer_name') | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="triple-rows">
              <div class="flex flex-row items-center gap-5x">
                <type-indicator [type]="row.type"></type-indicator>
                <div class="flex flex-col">
                  <span class="cell-row caption-medium" *ngIf="row.offerNumber"
                    >{{row.offerNumber}}</span
                  >
                  <span class="cell-row">{{row.name || '-'}}</span>
                </div>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="assignedTo">
          <mat-header-cell *matHeaderCellDef>
            <span>
              {{(translationsPath + '.table.offer_purchasing_manager') |
              translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="flex flex-col">
              <span *ngFor="let user of row.assignedTo">
                {{user.name || user.email}}
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="approved">
          <mat-header-cell *matHeaderCellDef class="cell-center">
            <span mat-sort-header>
              {{(translationsPath + '.table.offer_approved_products') |
              translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="cell-center">
            <span> {{row.confirmedProductCount}} / {{row.productCount}} </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="productCount">
          <mat-header-cell *matHeaderCellDef class="cell-center">
            <div mat-sort-header>
              <span
                [innerHTML]="translationsPath + '.table.offer_products_count' | translate"
              ></span>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="cell-center"> {{row.productCount}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{(translationsPath + '.table.offer_status') | translate}}
            </span>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            [ngSwitch]="kind"
          >
            <status-indicator
              [status]="getReceivingOfferStatusProgress(row.status)"
              *ngSwitchCase="OfferKind.ReceivingOffer"
              [date]="row.modifiedAt"
              [text]="row.status | translateEnum : 'ReceivingOfferStatus'"
            ></status-indicator>

            <status-indicator
              [status]="getOfferRequestStatusProgress(row.status)"
              *ngSwitchCase="OfferKind.OfferRequest"
              [date]="row.modifiedAt"
              [text]="row.status | translateEnum : 'OfferRequestStatus'"
            ></status-indicator>

            <status-indicator
              [status]="getSendingOfferStatusProgress(row.status)"
              *ngSwitchCase="OfferKind.SupplierOffer"
              [date]="row.modifiedAt"
              [text]="row.status | translateEnum : 'SupplierOfferStatus'"
            ></status-indicator>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="table.columns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: table.columns;"
          class="table-row-hover"
          [class.new]="row.isNew"
          routerLink="/offers/{{row.id}}"
          [class.table-row-selected]="isOfferSelected(row)"
        ></mat-row>
      </mat-table>
    </div>

    <no-content
      *ngIf="!hasOffers"
      image="no-offers"
      heading="cards.offers.no_offers_heading"
      [text]="canManageSupplierOffers ? 'cards.offers.no_offers_supplier_text' : 'cards.offers.no_offers_retailer_text'"
    >
    </no-content>

    <data-table-footer
      [localStorageKey]="LOCAL_STORAGE_KEY"
      (paginator)="hookPaginator($event)"
      [search]="search"
      (onSearch)="onSearch($event)"
      [(isFullScreen)]="state.isFullScreen"
      (onToggleFullScreen)="state.isFullScreen = $event"
      [(zoom)]="state.zoom"
      (onLoad)="onLoad()"
    >
    </data-table-footer>
  </div>
</card>

<a class="no-display" #download></a>
